module.exports = __webpack_public_path__ + "img/Frame2.1f62cae3.png";